import { UserFeatureModuleKey } from "modules/user/types/entities";
import { IFeatureModulesResponse } from "modules/user/types/res";

export const canAccess = ({
  features,
  key,
  projectId,
  isBetaUser
}: {
  features: IFeatureModulesResponse;
  key: UserFeatureModuleKey;
  isBetaUser: boolean;
  projectId?: string | null;
}) => {
  const featureModule = features.modules.find(
    featureModule => featureModule.key === key
  );

  if (!featureModule) return false;

  if (featureModule.beta && isBetaUser) return true;

  const userModuleEnabled = features.user_access.enabled.includes(key);
  const projectModuleEnabled = !!(
    projectId &&
    projectId !== "all" &&
    features.projects_access[projectId]?.enabled.includes(key)
  );
  const accountModuleEnabled = features.account_access.enabled.includes(key);

  const userModuleDisabled = features.user_access.disabled.includes(key);
  const projectModuleDisabled = !!(
    projectId &&
    projectId !== "all" &&
    features.projects_access[projectId]?.disabled.includes(key)
  );
  const accountModuleDisabled = features.account_access.disabled.includes(key);

  if (featureModule.is_open_to_all) {
    // no blockers
    return (
      !userModuleDisabled && !projectModuleDisabled && !accountModuleDisabled
    );
  }

  // check user module
  if (userModuleEnabled) return true;
  if (userModuleDisabled) return false;

  // check project module
  if (projectModuleEnabled) return true;
  if (projectModuleDisabled) return false;

  // check account module
  return accountModuleEnabled && !accountModuleDisabled;
};
